import React from "react";

import classnames from "classnames";
import { toggleSavePlan } from "ComparePlans/redux";
import { useDispatch } from "react-redux";
import AnalyticsTracking from "Utils/AnalyticsTracking";

import { LabelSmall } from "Cobalt/BodyText";
import { Checkbox } from "Cobalt/Checkbox";
import type { CheckboxProps } from "Theme/Checkbox";

import makeBem from "Utils/makeBem";

const bem = makeBem("QuotePagePlanCard");

const ANALYTICS_LOCATION = "expanding_plan_card";

export type CompareToggleButtonProps = CheckboxProps & {
  planId: string;
};

export const CompareToggleButton = ({ planId, checked, ...props }: CompareToggleButtonProps) => {
  const dispatch = useDispatch();
  const handleCompare = (e: React.SyntheticEvent<HTMLInputElement>) => {
    e.stopPropagation();
    AnalyticsTracking.trackEvent("quote_page_click_compare", {
      location: ANALYTICS_LOCATION,
    });

    dispatch(toggleSavePlan(planId, "plan_card_bottom_right"));
  };
  const classes = classnames(bem("compare"), {
    [bem("compare", "checked")]: checked,
  });

  return (
    <LabelSmall className={classes}>
      <Checkbox label="Compare" checked={checked} onClick={handleCompare} readOnly {...props} />
    </LabelSmall>
  );
};
